import React from 'react';
import PropTypes from 'prop-types';
import { DeviceMeta } from 'Roblox';

const { isInApp } = DeviceMeta();

function StipendSection({ translate, planInfo }) {
  function getRobuxPackage(index, robux, price) {
    const robuxText = translate('Label.AmountPerMonth', {
      amount: robux,
      subTextStart: '',
      subTextEnd: ''
    });
    const robuxHtmlElement = translate('Label.AmountPerMonth', {
      amount: robux,
      subTextStart: '<span class="font-annotation">',
      subTextEnd: '</span>'
    });

    const robuxClass = () => {
      return isInApp ? 'icon-robux-medium' : 'icon-robux-medium-desktop';
    };

    return (
      <div className='div-table-cell robux-package-item '>
        <div className='medium-header'>{translate('Label.PremiumPlanName', { type: robux })}</div>
        <div className={robuxClass()} />
        <div className='robux-package-name'>
          <div
            className='extra-bold-header'
            data-text={robuxText}
            dangerouslySetInnerHTML={{
              __html: robuxHtmlElement
            }}
          />
        </div>
        <div className='font-header-2 text-disabled'>
          {price.currency.currencySymbol + price.amount}
        </div>
      </div>
    );
  }
  return (
    <div className='stipend-section'>
      <div className='robux-bg' />
      <div className='stipend-sec-header left-header'>
        <div className='font-title'>{translate('Heading.RobuxEveryMonth')}</div>
        <div className='font-header-2 text-subheader'>
          {translate('Description.ReceiveRobuxMonthly')}
        </div>
      </div>
      <div className='desktop-view'>
        <div className='div-table robux-package-container'>
          <div className='div-table-row'>
            {planInfo &&
              planInfo.map((plan, index) => {
                return getRobuxPackage(index, plan.robuxAmount, plan.price, planInfo.length === 1);
              })}
          </div>
        </div>
      </div>
      <div className='mobile-view robux-package-container'>
        <div className='div-table'>
          {planInfo && planInfo.length > 1 && (
            <div className='div-table-row '>
              {planInfo[0] && getRobuxPackage(0, planInfo[0].robuxAmount, planInfo[0].price)}
              <div className='div-table-row '>
                {planInfo[1] && getRobuxPackage(1, planInfo[1].robuxAmount, planInfo[1].price)}
              </div>
              <div className='div-table-row'>
                {planInfo[2] && getRobuxPackage(2, planInfo[2].robuxAmount, planInfo[2].price)}
              </div>
            </div>
          )}
          {planInfo && planInfo.length === 1 && (
            <div className='div-table-row single-package'>
              {getRobuxPackage(0, planInfo[0].robuxAmount, planInfo[0].price)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

StipendSection.propTypes = {
  translate: PropTypes.func.isRequired,
  planInfo: PropTypes.arrayOf(
    PropTypes.shape({
      productId: PropTypes.number.isRequired,
      robuxAmount: PropTypes.string.isRequired,
      price: PropTypes.shape({
        amount: PropTypes.number.isRequired,
        currency: PropTypes.shape({
          currencySymbol: PropTypes.string.isRequired
        }).isRequired
      }).isRequired
    })
  ).isRequired
};

export default StipendSection;
